import { IFeeds } from './sharedTypes'
import type { CamelCasedPropertiesDeep } from 'type-fest'

export type CamelCasedFeeds = CamelCasedPropertiesDeep<IFeeds>
export type GetFeeds = (query: string | number) => Promise<CamelCasedFeeds>
